import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import Actions from 'actions/Actions';
import MfaActions from 'actions/mfaActions';
import UserActions from 'actions/UserActions';

import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import EmailVerificationModalEN from 'components/GlobalModals/EmailVerificationModal/locales/EmailVerificationModal_en_US';
import EmailVerificationModalFR from 'components/GlobalModals/EmailVerificationModal/locales/EmailVerificationModal_fr_CA';
import { MFA_MODE } from 'constants/phoneVerification';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(EmailVerificationModalEN, EmailVerificationModalFR);

const localization = createStructuredSelector({
    modalTitle: getTextFromResource(getText, 'modalTitle'),
    step1Title: getTextFromResource(getText, 'step1Title'),
    step1MessageLine1: getTextFromResource(getText, 'step1MessageLine1'),
    step1MessageLine2: (state, ownProps) => getTextFromResource(getText, 'step1MessageLine2', [ownProps.email])(state),
    step1MessageLine3: getTextFromResource(getText, 'step1MessageLine3'),
    termsOfUse: getTextFromResource(getText, 'termsOfUse'),
    step1MessageLine3Part2: getTextFromResource(getText, 'step1MessageLine3Part2'),
    privacyPolicy: getTextFromResource(getText, 'privacyPolicy'),
    send: getTextFromResource(getText, 'send'),
    infoTitle: getTextFromResource(getText, 'infoTitle'),
    infoMessage: getTextFromResource(getText, 'infoMessage'),
    infoOk: getTextFromResource(getText, 'infoOk'),
    step2Title: getTextFromResource(getText, 'step2Title'),
    step2MessageLine1: (state, ownProps) => getTextFromResource(getText, 'step2MessageLine1', [ownProps.email])(state),
    step2MessageLine2: getTextFromResource(getText, 'step2MessageLine2'),
    resend: getTextFromResource(getText, 'resend'),
    step2MessageLine2Part2: getTextFromResource(getText, 'step2MessageLine2Part2'),
    seconds: getTextFromResource(getText, 'seconds'),
    errorOtpIncorrect: getTextFromResource(getText, 'errorOtpIncorrect'),
    infoErrorTitle: getTextFromResource(getText, 'infoErrorTitle'),
    infoErrorMessage: getTextFromResource(getText, 'infoErrorMessage'),
    errorGenericMessage: getTextFromResource(getText, 'errorGenericMessage'),
    infoErrorTooManyAttemptsTitle: getTextFromResource(getText, 'infoErrorTooManyAttemptsTitle'),
    infoErrorTooManyAttemptsMessage: getTextFromResource(getText, 'infoErrorTooManyAttemptsMessage'),
    accessibilityInfoIcon: getTextFromResource(getText, 'accessibilityInfoIcon'),
    expiredOTP: getTextFromResource(getText, 'expiredOTP')
});

const fields = createStructuredSelector({ localization });

const functions = (dispatch, ownProps) => ({
    dispatch,
    onDismiss: () => {
        dispatch(Actions.showEmailVerificationModal({ isOpen: false }));
        dispatch(Actions.showSignInModal({ isOpen: true }));
    },
    showInfoModal: (infoModalOptions = {}) => dispatch(Actions.showInfoModal({ ...infoModalOptions, isOpen: true })),
    sendEmailOTP: () => dispatch(MfaActions.validateMFAEmailPhone(null, ownProps.email, MFA_MODE.EMAIL)),
    checkOTP: otpCode => dispatch(MfaActions.validateOTP(ownProps.email, otpCode, MFA_MODE.EMAIL, ownProps.keepSignedIn)),
    onMFASuccess: response => {
        dispatch(Actions.showEmailVerificationModal({ isOpen: false }));
        // Complete the login flow after successful OTP verification
        dispatch(
            UserActions.signInSuccessAfterMFA(
                response,
                ownProps.email,
                ownProps.keepSignedIn,
                ownProps.successCallback,
                ownProps.biAccountInfo,
                ownProps.analyticsData,
                ownProps.anonymousToken
            )
        );
    }
});

const withEmailVerificationModalProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withEmailVerificationModalProps
};
